import { combineReducers } from '@reduxjs/toolkit';
import { projectDatasetReducer } from './project-slices/project-dataset-slice';

export const projectReducers = combineReducers({
  projectDataset: projectDatasetReducer,
});
